// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/fonts/PublicSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-family-primary: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
}

body {
  height: 100%;
  margin: 0;
  font-family: var(--font-family-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root,
button,
input,
select,
textarea,
.MuiTypography-root,
.MuiButton-root {
  font-family: var(--font-family-primary);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
/* Import Google Font
@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;700&display=swap');
} */

/* Custom Font */
/* @font-face {
  font-family: 'ADLaM Display';
  src: url('../fonts/ADLaMDisplay-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
} */
@font-face {
    font-family: 'Public Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE;4FAC0F;AAC5F;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,uCAAuC;EACvC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;;;EAOE,uCAAuC;AACzC;;AAEA;EACE;aACW;AACb;AACA;;GAEG;;AAEH,gBAAgB;AAChB;;;;;GAKG;AACH;IACI,0BAA0B;IAC1B,+DAAsE;IACtE,mBAAmB;IACnB,kBAAkB;EACpB","sourcesContent":[":root {\n  --font-family-primary: 'Public Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',\n    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n}\n\nbody {\n  height: 100%;\n  margin: 0;\n  font-family: var(--font-family-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root,\nbutton,\ninput,\nselect,\ntextarea,\n.MuiTypography-root,\n.MuiButton-root {\n  font-family: var(--font-family-primary);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n/* Import Google Font\n@import url('https://fonts.googleapis.com/css2?family=Public+Sans:wght@400;500;700&display=swap');\n} */\n\n/* Custom Font */\n/* @font-face {\n  font-family: 'ADLaM Display';\n  src: url('../fonts/ADLaMDisplay-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n} */\n@font-face {\n    font-family: 'Public Sans';\n    src: url('./components/fonts/PublicSans-Light.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
